import { Link } from 'react-router-dom';
import S from './style';
import data from '../../services/data';
import dataen from '../../services/dataen';
import { LocaleContext } from '../../locale-context';
import TranslateStatic from '../../locales/TranslateStatic';

export function Category() {
  const renderCategories = (items) => (
    <div className="grid-container">
      {items.map((x, i) => (
        <Link to={x.category.link} key={i}>
          <div className="category-card">
            <div className="image-wrapper">
              <img src={x.category.imgsrc} alt={x.category.name} />
            </div>
            <div className="card-content">
              <h2>{x.category.name}</h2>
            </div>
          </div>
        </Link>
      ))}
    </div>
  );

  return (
    <S.PageWrapper>
      <S.HeroSection>
        <div className="hero-content">
          <h1><TranslateStatic string="BilimselToplantı" /></h1>
          <S.Breadcrumb>
            <Link to="/"><TranslateStatic string="home" /></Link>
            <span className="separator">/</span>
            <TranslateStatic string="BilimselToplantı" />
          </S.Breadcrumb>
        </div>
      </S.HeroSection>

      <S.ContentWrapper>
        <div className="gallery-container">
          <div className="section-header">
            <h2><TranslateStatic string="TümBilimselToplantı" /></h2>
          </div>
          
          <LocaleContext.Consumer>
            {(value) => {
              if (value === "en") {
                return renderCategories(dataen);
              } else if (value === "tr") {
                return renderCategories(data);
              } else {
                return renderCategories(dataen);
              }
            }}
          </LocaleContext.Consumer>
        </div>
      </S.ContentWrapper>
    </S.PageWrapper>
  );
}
